import React, { Component } from 'react';
import cx from 'classnames/bind';
import Tags from './Tags';
import { Example, Properties, SourceCode } from 'examples';
import DefaultTagRenderer from './DefaultTagRenderer';
import Icon from '../Icon/Icon';
import Group from '../Group/Group';

export default class TagsExample extends Component {

  constructor(props) {
    super(props);
    this.state = {
      value: 'Tag 1,Tag 2,Tag 3,Tag 4,Tag 5',
      // value: ['Tag 1', 'Tag 2', 'Tag 3', 'Tag 4', 'Tag 5'],
    };
  }

  onChange = e => this.setState(e.target.value);

  onDelete = (e, indexOfDeletedTag) => this.setState({ value: e.target.value });

  itemRenderer = (tag, className, onClick) => {
    const isHenrik = tag === 'Henrik';

    return (
      <DefaultTagRenderer key={tag} tag={tag} className={cx({ invalid: isHenrik })} onClick={onClick} title={isHenrik ? 'Moved to Video team' : undefined}>
        <Icon name="user"/>
      </DefaultTagRenderer>
    );
  };

  render() {
    return (
      <Example {...this.props}>
        <Properties onChange={this.onChange} defaultProps={Tags.defaultProps} propTypes={Tags.propTypes} propValues={this.state}/>
        <Group>
          <Group className="tags">
            <Tags {...this.state} onDelete={this.onDelete}/>
          </Group>
          <Group title="Using custom renderer">
            <div className="custom-tags">
              <Tags value={['Aleksandra', 'Are', 'Ketil', 'Henrik', 'Marius', 'Tor Erik', 'Tormod']} itemRenderer={this.itemRenderer}/>
            </div>
          </Group>
        </Group>
        <SourceCode querySelector=".tags" title="Generated HTML (with wrapper DIV)"/>
      </Example>
    );
  }

}
